import { CommentContextProvider, } from './CommentContextProvider';
import CommentContextContainer from './CommentContextProvider.container';
export default CommentContextContainer(CommentContextProvider);
//# sourceMappingURL=index.js.map